import { ImmutableEntity as _IE, MutableEntity as _ME, SystemImmutableEntity as _SIE, SystemMutableEntity as _SME } from './common';
import { Event as _Event } from './event';
import { UniqueId as _UniqueId } from './id';
import { MetadataField as _MetadataField } from './metadataField';
import {
  Session as _Session,
  SessionIdentifier as _SessionIdentifier,
  TemporaryUserIdentifier as _TemporaryUserIdentifier,
} from './session';
import { User as _User, UserIdentifier as _UserIdentifier } from './user';
export namespace _Object {
  export import ImmutableEntity = _IE;
  export import MutableEntity = _ME;
  export import SystemImmutableEntity = _SIE;
  export import SystemMutableEntity = _SME;
  export import UniqueId = _UniqueId;

  export import Event = _Event;
  export import Session = _Session;
  export import SessionIdentifier = _SessionIdentifier;
  export import TemporaryUserIdentifier = _TemporaryUserIdentifier;
  export import User = _User;
  export import UserIdentifier = _UserIdentifier;
  export import MetadataField = _MetadataField;
}
